import Text from 'components/Text/Text';
import React, { useContext, useState } from 'react';
import { Collapse } from 'antd';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import classNames from 'classnames';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { Link } from 'react-router-dom';
import style from './RestaurantsDropdown.module.scss';

const { Panel } = Collapse;

const RestaurantsDropdown: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const [open, setOpen] = useState<boolean>(false);
	const arrowClasses = classNames(style.arrow, { [style.active]: open });

	const toggleOpen = () => {
		setOpen((prevState) => !prevState);
	};

	const CollapseHeader = () => {
		return (
			<div className={style.collapseHeaderContainer}>
				<Text
					className={style.collapseHeaderHeading}
					translationNameSpace="form"
					translationKey="restaurantsLabel"
					theme="neutralLight"
					size="xs"
				/>
				<div className={style.collapseHeaderText}>{customerForFullInfo?.restaurantsCount}</div>
			</div>
		);
	};

	return (
		<Collapse
			className={style.collapse}
			bordered={false}
			expandIconPosition="right"
			onChange={toggleOpen}
			expandIcon={() => (
				<svg className={arrowClasses}>
					<use xlinkHref={`${breadcrumbs}#closeInfo`} />
				</svg>
			)}>
			<Panel key="restaurantsCount" header={<CollapseHeader />} className={style.collapsePanel}>
				{customerForFullInfo?.customerRestaurants.map((el) => (
					<Link
						className={style.link}
						key={el.id}
						target={`blank_${Date.now()}`}
						rel="noopener noreferrer"
						to={`/clients/restaurants?restaurantFullInfoID=${el.id}`}>
						<div className={style.collapseItem}>
							<svg className={style.icon}>
								<use xlinkHref={`${breadcrumbs}#locationMark`} />
							</svg>
							{el.address}
						</div>
					</Link>
				))}
			</Panel>
		</Collapse>
	);
};

export default RestaurantsDropdown;
